import { render, staticRenderFns } from "./accept-image.vue?vue&type=template&id=99537070&scoped=true&"
import script from "./accept-image.vue?vue&type=script&lang=js&"
export * from "./accept-image.vue?vue&type=script&lang=js&"
import style0 from "./accept-image.vue?vue&type=style&index=0&id=99537070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99537070",
  null
  
)

export default component.exports